export default function PerformantaScolaraPage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex justify-center">
          <iframe
            src="/educatie/performantaScolara/REZULTATE LA  CONCURSURILE ȘI OLIMPIADELE  ȘCOLARE ANUL ȘCOLAR  2024.pdf"
            title="Orar 2025-2026"
            className="w-full h-[90vh] border-0"
          ></iframe>
        </div>
      </main>
    </div>
  );
}
